<script>
    import { getContext } from 'svelte';
    import { Policy, Language } from "@Store";
    import Question from "@components/Question.svelte";
    import { validatePolicy, getAnswerText, isAnsweredById, getNamedValuesMap } from "@helpers/validator";
    import { policyQuestions } from "@helpers/questions";
    import 'animate.css';
    const CONTEXT = getContext('CONTEXT');

    // Call the function to get the questions object
    $: questionsList = policyQuestions($Policy);

    $: cgl = getAnswerText($Policy, questionsList.please_indicate_which_insurance_coverage_you_are_applying_for_question);
    $: first_answer = isAnsweredById($Policy, questionsList.please_indicate_which_insurance_coverage_you_are_applying_for_question);
    $: cgl_and_property_answer = cgl === 'CGL & Property';
    $: no_coverage_answer = cgl === 'None';

    $: sole_practitioner = getNamedValuesMap($Policy).sp_or_clinic?.toLowerCase() === 'sole practitioner';
    $: is_clinic = getNamedValuesMap($Policy).sp_or_clinic?.toLowerCase() === 'clinic';
    $: over_25_years_old = getAnswerText($Policy, questionsList.building_more_than_25_years_old_question) === 'yes';
    $: has_multiple_locations = getAnswerText($Policy, questionsList.do_you_have_multiple_locations_question) === 'yes';
    $: lease_or_own_premises = getAnswerText($Policy, questionsList.do_you_lease_or_own_your_premises_question) === 'Own Building' || getAnswerText($Policy, questionsList.do_you_lease_or_own_your_premises_question) === 'Own Condo';
    $: show_insure_building_question = lease_or_own_premises && getAnswerText($Policy, questionsList.do_you_wish_to_insure_your_building_question) === 'yes';

    $: mortgagee_loss_payee_answer = getAnswerText($Policy, questionsList.mortgagee_loss_payee_question) === 'yes';

    $: sole_prac_cgl = getAnswerText($Policy, questionsList.please_indicate_which_insurance_coverage_you_are_applying_for_question) === 'CGL Only (Sole Practitioner)';

    $: clinic_size = getNamedValuesMap($Policy).clinic_size?.toLowerCase();

    function handleAnswer(e) {
        CONTEXT.handleAnswer(e);
    }

    $: valid = validatePolicy($Policy);  

    $: {
        CONTEXT.routeValidation.update(validation => ({
            ...validation,
            policy: valid
        }));
    }
</script>

<div>
    {#if questionsList.please_indicate_which_insurance_coverage_you_are_applying_for_question}
        <Question question={questionsList.please_indicate_which_insurance_coverage_you_are_applying_for_question} policy={$Policy} remove_options={[...(is_clinic ? [0] : []), ...(sole_practitioner ? [2] : [])]} on:answered={(e) => handleAnswer(e.detail)} />
    {/if}

    {#if !no_coverage_answer && first_answer}
        {#if questionsList.commercial_general_liability_limits_of_insurance_question}
            <Question question={questionsList.commercial_general_liability_limits_of_insurance_question} required={true} remove_options={sole_prac_cgl ? [1] : []} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
        {/if}
        
        {#if questionsList.would_you_like_to_add_contents_coverage_question && cgl_and_property_answer}
            <Question question={questionsList.would_you_like_to_add_contents_coverage_question} required={true} increment={clinic_size !== '1-2' && !sole_practitioner ? 50000 : null} remove_options={clinic_size === '1-2' || sole_practitioner ? [10,11,12,13,14,15,16,17,18,19,20] : [0,1,2,3]} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
        {/if}

        {#if cgl === 'CGL & Property'}
            {#if questionsList.crime_limit_question && clinic_size !== '1-2'}
                <Question question={questionsList.crime_limit_question} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
            {/if}
            {#if questionsList.year_of_construction_question}
                <Question question={questionsList.year_of_construction_question} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
            {/if}
            {#if questionsList.square_footage_question}
                <Question question={questionsList.square_footage_question} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
            {/if}
            {#if questionsList.construction_question}
                <Question question={questionsList.construction_question} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
            {/if}
            {#if questionsList.number_of_storeys_question}
                <Question question={questionsList.number_of_storeys_question} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
            {/if}
            {#if questionsList.building_more_than_25_years_old_question}
                <Question question={questionsList.building_more_than_25_years_old_question} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
            {/if}
            {#if over_25_years_old}
                <div class="question-group">
                    <h2 class="section-subheading">{($Language === 'fr') ? "Veuillez fournir l'année de la dernière mise à jour des éléments suivants:" : 'Please provide the year the following was most recently updated:'}</h2>
                    <div class="question-group-items">
                        {#if questionsList.roof_question}
                            <Question question={questionsList.roof_question} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
                        {/if}
                        {#if questionsList.plumbing_question}
                            <Question question={questionsList.plumbing_question} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
                        {/if}
                        {#if questionsList.heating_question}
                            <Question question={questionsList.heating_question} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
                        {/if}
                        {#if questionsList.electrical_question}
                            <Question question={questionsList.electrical_question} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
                        {/if}
                    </div>
                </div>
            {/if}
            {#if questionsList.distance_to_hydrants_less_than_300m_question}
                <Question question={questionsList.distance_to_hydrants_less_than_300m_question} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
            {/if}
            {#if questionsList.distance_to_firehall_less_than_8km_question}
                <Question question={questionsList.distance_to_firehall_less_than_8km_question} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
            {/if}
            {#if questionsList.percent_sprinkled_question}
                <Question question={questionsList.percent_sprinkled_question} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
            {/if}
            {#if questionsList.burglar_alarm_question}
                <Question question={questionsList.burglar_alarm_question} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
            {/if}
            {#if questionsList.mortgagee_loss_payee_question}
                <Question question={questionsList.mortgagee_loss_payee_question} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
            {/if}
            {#if mortgagee_loss_payee_answer}
                {#if questionsList.name_and_address_of_mortgagee_loss_payee_question}
                    <Question question={questionsList.name_and_address_of_mortgagee_loss_payee_question} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
                {/if}
            {/if}

            {#if questionsList.do_you_lease_or_own_your_premises_question}
                <Question question={questionsList.do_you_lease_or_own_your_premises_question} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
            {/if}
            {#if questionsList.do_you_wish_to_insure_your_building_question && lease_or_own_premises}
                <Question question={questionsList.do_you_wish_to_insure_your_building_question} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
            {/if}
            {#if questionsList.building_limit_question && show_insure_building_question}
                <Question question={questionsList.building_limit_question} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
            {/if}

            {#if questionsList.do_you_have_multiple_locations_question}
                <Question question={questionsList.do_you_have_multiple_locations_question} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
            {/if}
            {#if questionsList.additional_locations_question && has_multiple_locations}
                <Question question={questionsList.additional_locations_question} required={true} row_label="Location" row_start={2} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
            {:else if questionsList.please_list_all_locations_question && has_multiple_locations }
                <Question question={questionsList.please_list_all_locations_question} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
            {/if}

        {/if}
    {/if}

</div>


<style>
    /* Section Container Styles */
    .page-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 1rem;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    }
    
    .questions-wrapper {
        width: 100%;
        max-width: 500px;
        margin-bottom: 2rem;
    }
    .section-container {
        width: 100%;
        background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
        border: 2px solid #e9ecef;
        border-radius: 20px;
        box-sizing: border-box;
        padding: 2rem 1.5rem;
        margin: 2rem 0;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
    }
    
    .section-header {
        display: flex;
        align-items: center;
        gap: 1rem;
        padding-bottom: 1.5rem;
        border-bottom: 2px solid #e9ecef;
    }
    
    .section-icon {
        font-size: 2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 56px;
        height: 56px;
        background: linear-gradient(135deg, #fff3cd 0%, #fff8e1 100%);
        border-radius: 16px;
        flex-shrink: 0;
        box-shadow: 0 2px 8px rgba(255, 193, 7, 0.15);
    }
    
    .section-header h1 {
        font-size: 1.375rem;
        font-weight: 600;
        color: #1d1d1f;
        margin: 0;
        line-height: 1.3;
        letter-spacing: -0.01em;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    }
    
    .sub-questions {
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
    }
    
    .sub-question {
        position: relative;
    }
    
    .question-group {
        background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
        border: 2px solid #e9ecef;
        border-radius: 16px;
        padding: 1.5rem;
        margin: 1.5rem auto;
        max-width: 500px;
        box-sizing: border-box;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
    }

    .question-group :global(.question-wrapper) {
        max-width: 100%;
        padding: 1rem 0;
        padding-bottom: 0;
    }

    .section-subheading {
        text-align: center;
        font-size: 1.15rem;
        font-weight: 600;
        color: #1d1d1f;
        margin: 0 0 1.25rem;
        padding-bottom: 1rem;
        border-bottom: 2px solid #e9ecef;
        letter-spacing: -0.01em;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    }

    .question-group-items {
        display: flex;
        flex-direction: column;
        gap: 0.75rem;
    }

    @media (max-width: 768px) {
        .section-container {
            padding: 1.5rem 1rem;
            border-radius: 16px;
        }
    
        .section-header {
            flex-direction: column;
            align-items: flex-start;
            gap: 0.75rem;
        }
    
        .section-header h1 {
            font-size: 1.25rem;
        }
    
        .section-icon {
            width: 48px;
            height: 48px;
            font-size: 1.75rem;
        }
    
        .sub-question {
            padding-left: 1rem;
        }
    
        .sub-question::before {
            width: 3px;
        }
    }</style>